enum CypressIds {
  emailSignup = 'signupEmail',
  emailSignin = 'signinEmail',
  passwordSignin = 'signinPassword',
  loginButton = 'loginButton',
  nameSignup = 'signupName',
  passwordSignup = 'signupPassword',
  companyNameSignup = 'signupCompanyName',
  repeatPasswordSignup = 'signupRepeatPassword',
  signupButton = 'signupButton',
  nameBackup = 'backupName',
  emailBackup = 'backupEmail',
  selectState = 'selectState',
  newVaultButton = 'newVaultButton',
  vaultName = 'vaultName',
  createVaultButton = 'createVaultButton',
  successCreateVault = 'successCreateVault',
  addTemplateButton = 'addTemplateButton',
  vaultCard = 'vaultCard',
  confirmModalButton = 'confirmModalButton',
  navbarMenu = 'navbarMenu',
  goToSignUp = 'goToSignUp',
  templatesAddButton = 'TemplatesAddButton',
}

export default CypressIds;
